export const IS_VM_REGISTRATION_KEY = 'is_vm_registration'
